import * as React from 'react';
import { FeaturesCommon } from './FeaturesCommon';

export default function Features() {
  return <FeaturesCommon />;
}
